import { FaqType } from 'api/types';

export const filterVPPFAQs = (faqs: FaqType[] | null) => {
  const filteredFAQs = faqs?.sort((a, b) => a.order - b.order).filter((faq) => !faq.hidden);

  if (filteredFAQs) {
    return {
      vpp: filteredFAQs.filter((faq) => faq.tags.some((tag) => tag.tag === 'category:vpp')),
      vpp_benefits: filteredFAQs.filter((faq) =>
        faq.tags.some((tag) => tag.tag === 'category:vpp_benefits'),
      ),
    };
  }

  return null;
};

export default filterVPPFAQs;
